import { useState, useEffect, useRef } from 'react';
import Slidein from './slidein';
import Header from './header';
import './main.css';

function Main() {
//    const initialClips = JSON.parse(localStorage.getItem('clips')) || [];
    const initialClips = JSON.parse(localStorage.getItem('clips')) || [
        {id: 1, title: '文章をタッチすると\nクリップボードにコピーされます'},
        {id: 2, title: '文章は画面下の入力欄から登録できます\n文章はブラウザに保存されます'},
        {id: 3, title: '登録した文章は×ボタンで削除できるほか、\n左上の歯車アイコンからまとめて削除できます'}
    ];
    const [clips, setClips] = useState(initialClips);
    const [inputText, setInputText] = useState('');
    const [isSlideinOpen, setSlindeinOpen] = useState(false);
    const sectionInputRef = useRef(null);

    useEffect(() => {
        localStorage.setItem('clips', JSON.stringify(clips));
        adjustSectionClipsHeight();
    }, [clips]);

    useEffect(() => {
        window.addEventListener('resize', adjustSectionClipsHeight);
        return () => {
            window.removeEventListener('resize', adjustSectionClipsHeight);
        };
    }, []);

    const adjustSectionClipsHeight = () => {
        if(sectionInputRef.current) {
            const inputHeight = sectionInputRef.current.offsetHeight;
            document.body.style.marginBottom = inputHeight + 'px';
        }
    };

    const openSlidein = () => {
        setSlindeinOpen(true);
    };
    
    const closeSlidein = () => {
        setSlindeinOpen(false);
    };

    const AddClip = (title) => {
        setClips(prevClips => {
            const newClipId = prevClips.length + 1;
            const newClip = {id: newClipId, title: title};
            return [...prevClips, newClip];
        });
    };

    const handleCopyClip = (event) => {
        const text = event.target.textContent;
        navigator.clipboard.writeText(text);
        openSlidein();
    };

    const handleDeleteClip = (event) => {
        const clipId = parseInt(event.target.dataset.clipid);
        setClips(prevClips => prevClips.filter(clip => clip.id !== clipId));
        event.stopPropagation();
    };

    const handlePasteClipboard = async () => {
        const clipboardText = await navigator.clipboard.readText();
        setInputText(clipboardText);
    };

    const handleRegistAll = () => {
        if(inputText.trim() !== '') {
            AddClip(inputText);
        }
    };

    const handleRegistLine = () => {
        if(inputText.trim() !== '') {
            const lines = inputText.split('\n');
            lines.forEach(line => {
                AddClip(line);
            });
        }
    };

    const handleChangeInputText = (event) => {
        setInputText(event.target.value);
    };

    const handleDeleteAll = (event) => {
        const resultConfirm = window.confirm('すべてのクリップを削除します。よろしいですか？');
        if(!resultConfirm) {
            event.preventDefault();
        }
        else {
            setClips([]);
            localStorage.removeItem('clips');
        }
    };

    return (
        <div>
            <Header handleDeleteAll={handleDeleteAll} />

            <div className="container">
                <main className="main">
                    <section className="section_clips">
                        {clips.map(clip => (
                            <button key={clip.id} className="clip" onClick={handleCopyClip}>
                                <span className="clip_content"><pre>{clip.title}</pre></span>
                                <button data-clipid={clip.id} className="clip_delete" onClick={handleDeleteClip}></button>
                            </button>
                        ))}
                    </section>
                </main>

                <footer ref={sectionInputRef} className="section_input">
                    <div className="container">
                        <div className="section_input_text">
                            <textarea className="section_input_text_area" value={inputText} onChange={handleChangeInputText} />
                        </div>
                        <div className="section_input_buttons">
                            <div className="section_input_buttons_step01">
                                <button onClick={handlePasteClipboard}><span>クリップボードを</span><br /><span>貼り付け</span></button>
                            </div>
                            <div className="section_input_buttons_step02">
                                <button onClick={handleRegistAll}>まとめて登録</button>
                                <button onClick={handleRegistLine}>一行ずつ分けて登録</button>
                            </div>
                        </div>
                    </div>

                    <Slidein isOpen={isSlideinOpen} onClose={closeSlidein}>
                        <p>コピーしました</p>
                    </Slidein>
                </footer>
            </div>
        </div>
    );
}

export default Main;
